import React, { useState } from 'react';
import ErrorBoundary       from './components/ui/ErrorBoundary';
import EnvelopeScreen      from './screens/EnvelopeScreen';
import DockScene           from './screens/DockScene';
import TorontoSite         from './screens/TorontoSite';
import JapanSite           from './screens/JapanSite';

/**
 * Valid screen identifiers used by the routing state machine.
 * @enum {string}
 */
export const SCREENS = {
  ENVELOPE: 'envelope',
  DOCK:     'dock',
  TORONTO:  'toronto',
  JAPAN:    'japan',
};

/**
 * App — root component.
 *
 * Acts as a simple client-side router using a single `screen` state value.
 * No third-party router is needed given the linear guest journey:
 *   Envelope → Dock → Toronto OR Japan
 *
 * The outer wrapper is capped at 480 px to simulate a mobile viewport,
 * matching the pixel-art aesthetic. Remove max-width for a full-bleed desktop layout.
 */
export default function App() {
  const [screen, setScreen] = useState(SCREENS.ENVELOPE);

  /** Navigate to a named screen. */
  const go = (destination) => setScreen(destination);

  return (
    <ErrorBoundary>
      <div
        style={{
          maxWidth: 480,
          margin: '0 auto',
          boxShadow: '0 0 40px rgba(0,0,0,0.18)',
          minHeight: '100vh',
        }}
      >
        {screen === SCREENS.ENVELOPE && (
          <EnvelopeScreen onAccept={() => go(SCREENS.DOCK)} />
        )}
        {screen === SCREENS.DOCK && (
          <DockScene onBoard={(venue) => go(venue)} />
        )}
        {screen === SCREENS.TORONTO && (
          <TorontoSite onBack={() => go(SCREENS.DOCK)} />
        )}
        {screen === SCREENS.JAPAN && (
          <JapanSite onBack={() => go(SCREENS.DOCK)} />
        )}
      </div>
    </ErrorBoundary>
  );
}
